import type { CourseDetailSummaryPropertyInstructor } from './courseDetailSummaryPropertyInstructor';
import type { CourseDetailSummaryPropertyLevel } from './courseDetailSummaryPropertyLevel';
import type { CourseDetailSummaryPropertyMetadataTranslationsItem } from './courseDetailSummaryPropertyMetadataTranslationsItem';
import type { CourseDetailSummaryPropertyPrice } from './courseDetailSummaryPropertyPrice';

/**
 * 강의 요약 정보
 */
export type CourseDetailSummaryProperty = {
  /**
   * 강의 평균 평점 (0.0 ~ 5.0)
   * @nullable
   */
  averageRating?: number | null;
  /** 강좌 생성 시각 */
  readonly createdAt?: string;
  /** 강의 기본 언어 코드 (예: ko) */
  defaultLanguage: string;
  /**
   * 강좌에 대한 간략한 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 강좌를 수강 중인 총 학생 수
   * @nullable
   */
  enrollmentCount?: number | null;
  /** 강의 고유 ID (UUID) */
  id: string;
  /** 강사 정보 */
  instructor: CourseDetailSummaryPropertyInstructor;
  /** 강의 난이도 */
  level: CourseDetailSummaryPropertyLevel;
  /**
   * 강좌 관련 미디어 파일 URL 목록
   * @nullable
   */
  mediaFiles?: string[] | null;
  /** 언어별 요약/설명 번역 정보 */
  metadataTranslations?: CourseDetailSummaryPropertyMetadataTranslationsItem[];
  /** 수강 등록 없이 강의 본문을 열 수 있는지(게시된 강의). 서버가 강의를 내주는 기준과 같다 */
  openAccess?: boolean;
  /** 현재 사용자의 수강 여부 */
  owned?: boolean;
  /**
   * 강좌 가격 정보
   * @nullable
   */
  price?: CourseDetailSummaryPropertyPrice;
  /**
   * Pay 서버와 연결되는 상품 코드
   * @nullable
   */
  productCode?: string | null;
  /**
   * 현재 사용자의 수강 진행률 (0.0 ~ 1.0)
   * @nullable
   */
  progressRate?: number | null;
  /**
   * 강좌에 등록된 총 리뷰 수
   * @nullable
   */
  reviewCount?: number | null;
  /** 강의에서 지원하는 언어 코드 목록 */
  supportedLanguages?: string[];
  /**
   * 강좌 관련 태그 목록
   * @nullable
   */
  tags?: string[] | null;
  /** 강의 제목 */
  title: string;
  /** 강좌 마지막 수정 시각 */
  readonly updatedAt?: string;
};
